export const properties = {
  sword: {
    scale: 1.5,
    damage: 1,
    number: 1,
    rotSpeed: 2,
  },
  spike: {
    number: 1,
    damage: 1,
    spawnSpeed: 5,
    scale: 1,
  },
  fireball: {
    number: 1,
    damage: 1,
    speed: 200,
    spawnSpeed: 4,
    scale: 1,
  }
}